const muiSFStateTheme = {
    palette: {
        primary: {
            light: '#53398f',
            main: '#231161',
            dark: '#010037',
            contrastText: '#ffffff',
        },
        secondary: {
            light: '#FFFFA1',
            main: '#FFDC70',
            dark: '#C9AB40',
            contrastText: '#000000',
        },
        action: {
            hover: {
                dark: 'hsla(0,0%,100%,.14)',
            },
        },
    },
    typography: {
        useNextVariants: true,
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            "Lato",
            "Helvetica Neue",
            "Helvetica",
            "Arial",
            "sans-serif",
        ].join(','),
        fontSize: 16,
        htmlFontSize: (128/7),
    },
    spacing: (first, second, third, fourth) => {
        let unit = 8;

        let resultStr = calcPixels(first, unit);
        if (second) {
            resultStr += ' ' + calcPixels(second, unit);
        }
        if (third) {
            resultStr += ' ' + calcPixels(third, unit);
        }
        if (fourth) {
            resultStr += ' ' + calcPixels(fourth, unit);
        }
        return resultStr;
    },
    components: {
        MuiAlert: {
            styleOverrides: {
                standardSuccess: {
                    backgroundColor: "#EFF7EE",
                },
                standardWarning: {
                    backgroundColor: "#FDF4E7",
                },
                filledSuccess: {
                    backgroundColor: "#0A350C",
                    color: "white"
                },
                filledError: {
                    backgroundColor: "#431919",
                    color: "white"
                },
                filledWarning: {
                    backgroundColor: "#624412",
                    color: "#fff"
                },
                filledInfo: {
                    backgroundColor: "#07364A",
                    color: "#fff"
                },
                icon: {
                    ".MuiAlert-filledWarning &": {
                        color: "rgb(237, 108, 2)",
                    },
                    ".MuiAlert-filledSuccess &": {
                        color: "rgb(46, 125, 50)",
                    },
                    ".MuiAlert-filledInfo &" : {
                        color: "#4C91D0",
                    }
                }

            },
        },
        MUIDataTableSelectCell: {
            styleOverrides: {
                backgroundColor: "black",
            }
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    padding: 10,
                },
            },
        },
        MuiFormControlLabel: {
            styleOverrides: {
                root: {
                    marginBottom: 0,
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                },
            },
        },
        MuiSnackbarContent: {
            styleOverrides: {
                message: {
                    fontSize: '1.4rem',
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    ['@media (max-width:767px)']: {
                        '&.drupal-dialog-div': {
                            width: 'calc(100% - 20px)',
                            maxHeight: 'calc(100% - 48px)',
                            margin: '24px 10px',
                        }
                    }
                }
            }
        },
        MuiDialogTitle : {
            styleOverrides: {
                root: {
                    padding: "16px 42px 16px 24px",
                }
            }
        },
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    display: "inline-flex",
                    flexDirection: "columns",
                    position: "relative",
                    verticalAlign: "top",
                }
            }
        },
        MuiStepIcon: {
            styleOverrides: {
                root: {
                    fontSize: "1.75rem",
                }
            }
        }
    },
};

export default muiSFStateTheme;

function calcPixels(num, unit) {
    if (typeof num === 'number') return `${unit * num}px`;
    return num;
}